<template>
  <v-container fluid grid-list-md>
    <v-layout row justify-center align-center>
      <v-flex xs12 md8>
        <eimza-gate title="Excel Numara-Mesaj SMS">
          <v-alert style="overflow-x: auto;margin: 0 10px;" type="warning">
            <span>
              HATIRLATMA!
              <br>
              Ticari SMS içeriklerinde;
              firmalar için Mersis No, şahıs işletmelerinde ise;
              Ad Soyad ve TC.Kimlik Numarası, telefon veya email gibi iletişim bilgisinin
              RET Hizmeti ile birlikte bulunması önem teşkil etmektedir.
            </span>
          </v-alert>
          <v-card-text>
            <v-form ref="excelForm" lazy-validation>
              <v-layout wrap>
                <v-flex xs12>
                  <v-file-input
                    label="Dosya Seçiniz"
                    placeholder="SMS gönderilecek Excel dosyanızı seçiniz."
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    v-model="files"
                    validate-on-blur
                    :rules="[$rules.required({ falseValues: [null], message: 'Bir dosya yüklemelisiniz' })]"
                    required
                  ></v-file-input>
                </v-flex>
                <v-flex xs12 md6>
                  <senders-or-message-types
                    label="Gönderici Adı"
                    required
                    no-data-text="Aktif Gönderici Adı bulunmuyor"
                    :default="data.sender"
                    :items="senders"
                    item-text="text"
                    item-value="value"
                    :rules="[$rules.empty('Gönderici Adı')]"
                    @on:model-update="(val) => { data.sender = val; }"
                  ></senders-or-message-types>
                </v-flex>
                <v-flex xs12 md6>
                  <senders-or-message-types
                    label="Türü"
                    required
                    :items="types"
                    :default="data.default_message_type"
                    item-text="text"
                    item-value="value"
                    :rules="[$rules.required({ falseValues: [undefined, null], message: 'Mesaj türü seçimi yapmalısınız' })]"
                    @on:model-update="(val) => { data.message_type = val; }"
                  ></senders-or-message-types>
                </v-flex>
                <v-flex xs12 md12>
                  <time-type
                    :rules="[$rules.required({ falseValues: [undefined, null], message: 'Gönderim zamanı seçimi yapmalısınız' })]"
                    @type:update="(val) => (wTimeStat = val)"
                  ></time-type>
                </v-flex>
                <v-flex xs12 md6 v-if="wTimeStat">
                  <date-month-picker
                    label="Gönderme Tarihi"
                    :disable-prev="true"
                    :rules="[$rules.required({ falseValues: [''], message: 'Tarih seçimi yapmalısınız' })]"
                    @on:date-selected="(val) => { date = val; dateSelected = true; }"
                  ></date-month-picker>
                </v-flex>
                <v-flex xs12 md6 v-if="wTimeStat">
                  <time-picker
                    label="Gönderme Saati"
                    :rules="[$rules.empty('Gönderme Saati')]"
                    :valid="dateSelected"
                    @on:time-selected="(val) => { time = ` ${val}:00`; }"
                  ></time-picker>
                </v-flex>
                <v-flex xs12 md6 v-if="$store.state.iys_status === 1">
                  <message-type @type="(val) => (message_content_type = val)"></message-type>
                </v-flex>
              </v-layout>
            </v-form>
            <div class="d-flex">
              <excel-button type="number_message" class="mr-2"></excel-button>
              <v-spacer></v-spacer>
              <sms-confirmation
                :context="confirmation.context"
                :valid="confirmation.valid"
                @on:disagree="() => { $trigger('setPluginDialog'); confirmation.valid = !confirmation.valid; }"
                @on:agree="sendExcel"
              >
                <template v-slot:activator>
                  <v-btn color="primary" @click="smsPreview">
                    Mesajı Gönder <v-icon right dark>mdi-send</v-icon>
                  </v-btn>
                </template>
              </sms-confirmation>
            </div>
          </v-card-text>
        </eimza-gate>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { types } from '../../../../misc';
import EimzaGate from '../../../Components/EimzaGate.vue';
import SendersOrMessageTypes from '../../../Components/SMSConstants/SendersOrMessageTypes.vue';
import DateMonthPicker from '../../../Components/SMSConstants/DateMonthPicker.vue';
import TimePicker from '../../../Components/SMSConstants/TimePicker.vue';
import TimeType from '../../../Components/SMSConstants/TimeType.vue';
import ExcelButton from '../../../Components/Sms/ExcelButton.vue';
import SmsConfirmation from '../../../Components/SMSConfirmation.vue';
import MessageType from '../../../Components/SMSConstants/MessageType.vue';

export default {
  name: 'Excel',
  components: {
    EimzaGate,
    SmsConfirmation,
    TimeType,
    TimePicker,
    DateMonthPicker,
    SendersOrMessageTypes,
    ExcelButton,
    MessageType,
  },
  data: () => ({
    dateSelected: false,
    wTimeStat: false,
    time: '',
    date: '',
    types,
    files: null,
    data: {},
    confirmation: { valid: false, context: { examples: [] } },
    senders: [],
    message_content_type: null,
  }),
  created() {
    this.send({ route: 'sms/excel/nm' }).then(async (res) => {
      this.data = await res.data.data;
      this.senders = res.data.data.senders;
      // eslint-disable-next-line prefer-destructuring
      this.data.sender = this.senders[0];
      this.data.message_type = this.data.default_message_type;
    });
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    sendExcel() {
      if (this.$refs.excelForm.validate()) {
        const form = this.prepareOriginal();
        this.send({ route: 'sms/excel/nm/send', data: form, headers: { 'Content-Type': 'multipart/form-data' } })
          .then(() => this.resetForm());
      }
    },
    smsPreview() {
      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      this.confirmation.valid = this.$refs.excelForm.validate();
      if (this.$refs.excelForm.validate()) {
        const form = this.prepareOriginal();
        this.send({ route: 'sms/excel/nm/send/preview', data: form, headers: { 'Content-Type': 'multipart/form-data' } })
          .then((res) => { this.confirmation.context = res.data.data; });
      }
    },
    prepareOriginal() {
      this.data.send_time = this.date + this.time;
      this.data.excel = this.files;
      const form = new FormData();
      form.append('excel', this.data.excel);
      form.append('sender', this.data.sender);
      form.append('message_type', this.data.message_type);
      form.append('message_content_type', this.message_content_type);
      if (this.wTimeStat) form.append('send_time', this.data.send_time);
      return form;
    },
    resetForm() {
      this.$refs.excelForm.reset();
      this.wTimeStat = false;
    },
  },
};
</script>
